module.exports = __webpack_public_path__ + "img/content3-1.5c93b091.png";